import { useRouter } from "next/router";
import { useMemo } from "react";

/**
 * Returns the impersonate query parameter if present in the URL.
 * Used only for initiating impersonation - the backend cookie handles persistence.
 *
 * Returns:
 * - `undefined` while router is hydrating (callers should delay API calls)
 * - `null` when router is ready but no impersonate param is present
 * - `string` when router is ready and impersonate param is present
 */
export function useImpersonateParam(): string | null | undefined {
  const router = useRouter();
  return useMemo(() => {
    // Return undefined while router is hydrating to prevent premature API calls
    if (!router.isReady) {
      return undefined;
    }
    const param = router.query.impersonate;
    if (typeof param === "string" && param.length > 0) {
      return param;
    }
    return null;
  }, [router.isReady, router.query.impersonate]);
}
